// extracted by mini-css-extract-plugin
module.exports = {"blockbanner":"SingleTabEnforce_blockbanner__1fz8D"};